<template>
  <!-- 问卷管理 -->
  <div class="paginations" :style="{filter: this.$store.state.isVague?'blur(2px)':''}">
    <div class="table-search-box">
      <el-form :inline="true" :model="searchData" class="demo-form-inline">
        <!-- 防止输入框回车刷新页面 -->
        <el-form-item label="" v-show="false">
          <el-input></el-input>
        </el-form-item>
        <el-form-item label="资源库：">
          <el-input size="small" v-model="searchData.zykname" placeholder="请输入资源库"></el-input>
        </el-form-item>
        <el-form-item label="任务类型：">
          <el-select size="small" v-model="uploadBox.taskType" placeholder="请选择" filterable :popper-append-to-body="false">
            <el-option v-for="(item,index) in dropDown.taskTypeList" :key="index" :label="item" :value="item">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="平台：">
          <el-select size="small" v-model="uploadBox.platformid" placeholder="请选择" filterable :popper-append-to-body="false">
            <el-option v-for="(item,index) in dropDown.platformList" :key="index" :label="item" :value="item">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="推送状态：">
          <el-select size="small" v-model="uploadBox.status" placeholder="请选择" filterable :popper-append-to-body="false">
            <el-option v-for="(item,index) in dropDown.statusList" :key="index" :label="item" :value="item">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <div class="search_button">
            <i class="pointer el-icon-search" @click="search('')"></i>
            <i class="pointer el-icon-refresh-left" @click="reset"></i>
          </div>
        </el-form-item>
      </el-form>
      <div class="addition">
        <el-button @click="add('uploadBox')">
          添加
          <i class="h_icon icon-add"></i>
        </el-button>
      </div>
    </div>
    <div class="table_box">
      <el-table :data="tableObj.list" style="width: 100%">
        <el-table-column type="index" label="序号" align='center'></el-table-column>
        <el-table-column prop="title" label="任务概述" align='center'></el-table-column>
        <el-table-column prop="title" label="任务类型" align='center'></el-table-column>
        <el-table-column prop="title" label="平台名称" align='center'></el-table-column>
        <el-table-column prop="title" label="截止时间" align='center'></el-table-column>
        <el-table-column prop="title" label="预计推送时间" align='center'></el-table-column>
        <el-table-column prop="title" label="是否推送" align='center'></el-table-column>
        <el-table-column prop="title" label="创建日期" align='center'></el-table-column>
        <el-table-column label="操作" align='center'>
          <template slot-scope="scope">
            <i class="icona icon-edit" title="编辑" @click="edit(scope.row)"></i>
            <i class="icona icon-delete" title="删除" @click="deletes(scope.row.id)"></i>
            <i class="icona icon-download" title="下载" @click="download(scope.row.id)"></i>
          </template>
        </el-table-column>
      </el-table>
      <pageNumber :paginations="7" :pageNum="searchData.pageDto.pageNum" :pageSize="searchData.pageDto.pageSize" :total="tableObj.total" :jumpTo="tableObj.jumpTo" @currentChange="search"></pageNumber>
    </div>

    <!-- 添加弹窗 -->
    <el-dialog :title="uploadBox.title" :visible.sync="uploadBox.show" :close-on-click-modal="false" width="600px" class="pop_up" append-to-body :before-close="handleClose" @opened="opened">
      <el-form ref="uploadBox" :model="uploadBox.data" :rules="uploadBox.rules" label-width="130px">
        <el-form-item label="截止时间：" prop="deadline" required>
          <el-date-picker size="small" type="date" placeholder="选择日期" v-model="uploadBox.data.deadline" style="width: 100%;" popper-class="dateClass"></el-date-picker>
        </el-form-item>
        <el-form-item label="任务概述：" prop="taskContent" required>
          <el-input size="small" type="textarea" v-model="uploadBox.data.taskContent" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="类型：" prop="type" required>
          <el-radio-group v-model="uploadBox.data.type">
            <el-radio label="平台" value="1"></el-radio>
            <el-radio label="资源库" value="2"></el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="平台：" prop="platformid" required>
          <el-select size="small" v-model="uploadBox.data.platformid" placeholder="请选择" style="width: 100%;" filterable :popper-append-to-body="false" multiple>
            <el-option v-for="(item,index) in dropDown.platformList" :key="index" :label="item" :value="item">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="任务概述：" prop="zykids" required>
          <el-input size="small" type="textarea" v-model="uploadBox.data.zykids" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="上传推送需求：" prop="icon">
          <el-upload class="avatar-uploader" :action="$apiurls.upload_uploadFile" :headers="headers" :limit="1" :file-list="uploadBox.data.file" :on-success="handleAvatarSuccess" :on-remove="handleRemove">
            <i class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
      </el-form>
      <div class="tx-center">
        <el-button size="small" @click="submitUpload">确定</el-button>
        <el-button size="small" @click="handleClose">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>

import pageNumber from '@/components/pageNumber.vue' //分页

export default {
  components: {
    pageNumber
  },
  data() {
    return {
      headers: { "lrmv2token": sessionStorage.getItem('lrmv2token') },
      searchData: {
        zykname: '',
        taskType: '',
        platformid: '',
        status: '',
        pageDto: {
          pageNum: 1,//当前显示的页面页码数
          pageSize: 10,
        }
      },

      tableObj: {
        total: 0,
        jumpTo: 1,
        list: [{ title: 1 }]
      },

      uploadBox: {
        show: false,
        title: "编辑账号",
        data: {
          id: null,
          deadline: '',
          taskContent: '',
          type: '',
          platformid: '',
          zykids: '',
          file: []
        },
        rules: {
          deadline: [{ required: true, message: "学校名称不能为空！", trigger: 'blur' }],
          taskContent: [{ required: true, message: "所在省份不能为空！", trigger: 'blur' }],
          type: [{ required: true, message: "学校属性不能为空！", trigger: 'blur' }],
          platformid: [{ required: true, message: "学校代码不能为空！", trigger: 'blur' }],
          zykids: [{ required: true, message: "学校代码不能为空！", trigger: 'blur' }],
        },
      },

      dropDown: {   //下拉框
        taskTypeList: ['类型1', '类型2', '类型3'],
        platformList: ['平台1', '平台2', '平台3'],
        statusList: ['已推送', '未推送', '已逾期']
      }
    }
  },
  created() {
    // this.search()
  },
  methods: {
    // 查询表格数据
    search(type) {
      this.searchData.pageDto.pageNum = type ? type : 1
      this.tableObj.jumpTo = type ? type : 1
      this.$axios.post(this.$apiurls.account_getMenuList, {
        pageDto: {
          pageNum: this.searchData.pageDto.pageNum,
          pageSize: this.searchData.pageDto.pageSize
        },
        title: this.searchData.title
      }, {
        loading: false,
      }).then((res) => {
        if (res) {
          this.tableList = res.data.list
          this.searchData.pageDto.pageNum = res.data.pageNum
          this.tableObj.total = res.data.total
        }
      });
    },
    // 重置表格
    reset() {
      this.searchData.zykname = ''
      this.searchData.taskType = ''
      this.searchData.platformid = ''
      this.searchData.status = ''
      this.search()
    },
    // 编辑
    edit(row) {
      this.uploadBox.title = '编辑'
      this.uploadBox.show = true
      this.$store.commit('modifyVague', true);
      // this.uploadBox.data.id = row.id
      console.log("编辑", row);
    },
    // 删除
    deletes(id) {
      this.$store.commit('modifyVague', true);
      this.$confirm('此操作将永久删除该菜单, 是否继续?', '删除提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'error'
      }).then(() => {
        this.$axios.post(this.$apiurls.account_deleteMenuInfo, id, {
          loading: false,
        }).then((res) => {
          if (res) {
            if (res.data) {
              this.search('')
              this.$message({
                message: '删除成功！',
                type: 'success'
              });
            } else {
              this.$message.error('删除失败！')
            }
          }
          this.$store.commit('modifyVague', false);
          this.deleteId = ''
        });
      }).catch(() => {
        this.$store.commit('modifyVague', false);
      });
    },

    // 下载
    download(id) {
      console.log("下载", id);
    },

    // 新增
    add() {
      this.uploadBox.title = '新增'
      this.uploadBox.show = true
      this.$store.commit('modifyVague', true);
    },
    // 关闭弹窗
    handleClose() {
      this.uploadBox.show = false
      this.$store.commit('modifyVague', false);
    },
    // 确认新增
    submitUpload() {
      this.$refs.uploadBox.validate((valid) => {
        if (valid) {
          // var url = "/admin/school/add";
          // if (this.uploadBox.data.id != undefined) {
          //   url = "/admin/school/update";
          // }
          // this.$axios
          //   .post(url, this.uploadBox.data, {
          //     loading: true,
          //   })
          //   .then(() => {
          //     this.uploadBox.show = false;
          //             this.$message({
          //               message: this.uploadBox.id ? '编辑成功' : '添加成功',
          //               type: 'success'
          //             });
          //     this.search();
          //   });
        }
      });
    },
    // 文件上传成功
    handleAvatarSuccess(res, file) {
      console.log("上传文件", res, file);
      // this.uploadBox.icon = URL.createObjectURL(file.raw);
    },
    // 移除文件
    handleRemove(file, fileList) {
      console.log("移除文件", file, fileList);
    },
    opened() {
      this.$refs.uploadBox.clearValidate();
    },

  }
}
</script>


<style  lang="scss" src="@/assets/css/popUp.scss" scoped></style>
<style  lang="scss" src="@/assets/css/tableList.scss" scoped></style>
<style  lang="scss" src="@/assets/css/custom.scss" scoped></style>
<style lang="scss" scoped>
</style>
